import { Link } from "react-router-dom";
import style from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={style.footer}>
      <div className={style.container}>
        <div className={style.grid}>
          <div className={style.brand}>
            <h3>Vyra Pharma</h3>
            <p>Quality Medicines. Trusted Healthcare. Better Life.</p>
          </div>

          <div className={style.links}>
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/products">Products</Link>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact Us</Link>
          </div>

          <div className={style.links}>
            <h4>Contact</h4>
            <p>+91 9288544134</p>
            <p>vyrapharma@gmail.com</p>
            <p>Kolkata, West Bengal, India</p>
          </div>
        </div>

        <div className={style.bottom}>
          <p>© {new Date().getFullYear()} Vyra Pharmaceuticals Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
